import { Component, Prop, h } from '@stencil/core';
import icons from '../svg/system-icons';

/**
 * Subcomponent: renders system icons
 * @ssh
 * @ignore
 */
@Component({
  tag: 'hp6-system-icon',
  shadow: false, // Subcomponents should not have shadow DOM to avoid nested shadow DOM
})
export class SystemIcon {
  /**
   * Name of the icon
   */
  @Prop({ reflect: true }) name: string;

  render() {
    return <div class="svg-container system" innerHTML={icons[this.name]} />;
  }
}
